import { configQuery } from '@gig/magic-common';
import { __awaiter, __generator, __spreadArray } from 'tslib';

/**
 * Returns the pinned options for a dropdown by checking the pinnedDropdownValues config
 * @param elementId id of the dropdown component
 * @param dropdownOptions list of dropdown options
 * @returns list of dropdown options with pinned options first
 */
function getPinnedOptions(elementId, dropdownOptions) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var pinnedData, pinnedValues, pinnedOptions;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, configQuery('pinnedDropdownValues')];
                case 1:
                    pinnedData = (_b.sent()) || [];
                    pinnedValues = ((_a = pinnedData.find(function (entry) { return entry.dropdownId === elementId; })) === null || _a === void 0 ? void 0 : _a.values) ||
                        [];
                    pinnedOptions = pinnedValues
                        .map(function (value) {
                        return dropdownOptions.find(function (option) { return option.value === value; });
                    })
                        .filter(function (option) {
                        return option !== undefined && option !== null;
                    });
                    return [2 /*return*/, __spreadArray(__spreadArray([], pinnedOptions), dropdownOptions)];
            }
        });
    });
}

export { getPinnedOptions };
